import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import I18n from 'I18n';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import useContentPlatformPropertiesConfiguration from '../../hooks/useContentPlatformPropertiesConfiguration';
import { getPropertyOptions } from '../../utils/propertyOptionsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const TextCell = ({
  ariaLabel,
  value,
  dataTestId
}) => /*#__PURE__*/_jsx(TFlex, {
  direction: "column",
  children: /*#__PURE__*/_jsx("div", {
    "aria-label": ariaLabel || value,
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx("span", {
      "aria-hidden": true,
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: value
      })
    })
  })
});
export const LanguageCell = ({
  crmObject,
  propertyName
}) => {
  const language = getPropertyValue(crmObject, propertyName);
  const langKey = language ? `SharedI18nStrings.languageNames.${language}` : 'content-management-listing-lib.table.cells.emptyValues.language';
  return /*#__PURE__*/_jsx(TextCell, {
    value: I18n.text(langKey)
  });
};
export const TitleCell = ({
  crmObject,
  propertyName
}) => {
  const title = getPropertyValue(crmObject, propertyName);
  return /*#__PURE__*/_jsx(TextCell, {
    value: title || I18n.text('content-management-listing-lib.table.cells.emptyValues.title')
  });
};
export const ContentGroupNameCell = ({
  crmObject
}) => /*#__PURE__*/_jsx(TextCell, {
  value: getContentPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.CONTENT_GROUP_NAME)
});
export const CampaignCell = ({
  crmObject
}) => {
  const campaignName = getPropertyValue(crmObject, CONTENT_PLATFORM_PROPERTY_NAME.CAMPAIGN_NAME);
  return /*#__PURE__*/_jsx(TextCell, {
    value: campaignName || I18n.text('content-management-listing-lib.table.cells.emptyValues.campaign')
  });
};
export const TestStatusCell = ({
  crmObject,
  propertyName
}) => {
  const testStatus = getPropertyValue(crmObject, propertyName);
  const testStatusLangKey = `content-management-listing-lib.table.cells.${testStatus ? `testStatus.${testStatus}` : 'emptyValues.testStatus'}`;
  return /*#__PURE__*/_jsx(TextCell, {
    value: I18n.text(testStatusLangKey)
  });
};
export const ThemeCell = ({
  crmObject,
  propertyName
}) => {
  const {
    propertyDefinitionMap
  } = useContentPlatformPropertiesConfiguration();
  const themeOptions = getPropertyOptions(propertyDefinitionMap, 'hs_theme_path');
  const themePath = getPropertyValue(crmObject, propertyName);
  const theme = themeOptions.find(t => t.value === themePath);
  return /*#__PURE__*/_jsx(TextCell, {
    value: !themePath || !theme ? I18n.text('content-management-listing-lib.table.cells.emptyValues.theme') : theme.label
  });
};